import React from 'react';
import { Outlet } from 'react-router-dom';
import { Translate } from 'react-redux-i18n';
import { Grid, GridRow, GridColumn } from 'semantic-ui-react';
import BasePageView from '../../components/common/basePageView';
import SystemSettingsMenu from './SystemSettingsMenu';
import { i18nKeys } from './constants';
import { usePageTitle } from '../../hooks';
import { I18n } from 'react-redux-i18n';

const SystemSettings = () => {
  usePageTitle(I18n.t('page-titles.systemSettings', { defaultValue: 'System settings' }));

  return (
    <BasePageView
      isLoading={false}
      isLoadingError={false}
      backLink="/dashboard"
      backLinkTitle="Back to dashboard"
    >
      <h1>
        <Translate value={i18nKeys.TITLE} />
      </h1>
      <Grid>
        <GridRow>
          <GridColumn width={5}>
            <SystemSettingsMenu />
          </GridColumn>
          <GridColumn width={11}>
            <Outlet />
          </GridColumn>
        </GridRow>
      </Grid>
    </BasePageView>
  );
};

export default SystemSettings;
